// interceptorService.ts
import { interceptor } from "./interceptor";  

export const interceptorService = {
  getAgents: () => interceptor("/api/agents"),

  getAgentById: (id: string) => interceptor(`/api/agents/${id}`),

  createAgent: (payload: any) =>
    interceptor("/api/agents", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  updateAgent: (id: string, payload: any) =>
    interceptor(`/api/agents/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),

  deleteAgent: (id: string) =>
    interceptor(`/api/agents/${id}`, {
      method: "DELETE",
    }),

  get: (endpoint: string) =>
    interceptor(endpoint, {
      method: "GET",
    }),

  post: (endpoint: string, payload: any) =>
    interceptor(endpoint, {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  put: (endpoint: string, payload: any) =>
    interceptor(endpoint, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),

  delete: (endpoint: string) =>
    interceptor(endpoint, {
      method: "DELETE",
    }),
};
